/* Mobile QA runtime, 2026-08-08, revised.

   1. Videos kept decoding after they scrolled away. Pause off screen, resume
      only what was actually playing.
   2. The hero video downloaded eagerly on every connection. On a metered or
      slow link autoplay is dropped and the poster stands in.
   3. Animations run forever whether or not they are on screen. Rather than
      delete them, which was the wrong call in round one, pause them off screen
      by putting .ow-offscreen on the section.

   The GIFs are still NOT solved here. A GIF has no hardware decode path and
   cannot be paused from script. They have to be re-encoded as video. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var frugal = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));

  var vio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.dataset.owQaResume === '1') {
          v.dataset.owQaResume = '0';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else if (!v.paused) {
        v.dataset.owQaResume = '1';
        v.pause();
      }
    });
  }, { threshold: 0.01 });

  var sio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      e.target.classList.toggle('ow-offscreen', !e.isIntersecting);
    });
  }, { rootMargin: '200px 0px' });

  function bind() {
    var vids = document.querySelectorAll('video:not([data-ow-qa])');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      v.setAttribute('data-ow-qa', '1');
      v.setAttribute('playsinline', '');
      v.preload = v.autoplay ? 'metadata' : 'none';
      if (frugal && v.autoplay) {
        v.autoplay = false;
        v.removeAttribute('autoplay');
        try { v.pause(); } catch (err) {}
      }
      vio.observe(v);
    }
    var secs = document.querySelectorAll('.shopify-section:not([data-ow-qa-sec])');
    for (var j = 0; j < secs.length; j++) {
      secs[j].setAttribute('data-ow-qa-sec', '1');
      sio.observe(secs[j]);
    }
  }

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);

  if ('MutationObserver' in window) {
    new MutationObserver(bind).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
